import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, FlaskConicalIcon, BookOpenIcon, CheckCircle2Icon, ArrowDownIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSolutionSection() {
  const problems = ['Compraste creatina… pero no tenés idea si realmente es buena o mala.', 'Tomás creatina antes de entrenar porque creés que funciona como un pre-entreno.', 'Tomás creatina solo los días que entrenás, sin saber si eso tiene sentido.', 'Ves influencers recomendando creatina… pero no sabés si la recomiendan porque funciona o porque les pagan.', 'No sabés si la creatina es realmente para vos o si deberías tomar otra cosa.', 'Entrás a un negocio y ves decenas de marcas y presentaciones diferentes… y no tenés idea cuál elegir.', 'Tomás creatina durante dos o tres meses, la dejás, y después decís que no te dio resultados.', 'Comprás la más barata porque alguien dijo que todas son iguales… o comprás la más cara por miedo a perder calidad.'];
  return <section className="w-full bg-[#0E2238] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-165">
      <div className="max-w-7xl mx-auto" data-id="element-166">
        {/* BLOCK 1 — Problem Identification Grid */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-167">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-4 leading-tight" data-id="element-168">
            ¿Tomás o querés tomar creatina y{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500" data-id="element-169">
              te pasa esto?
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/70 max-w-2xl mx-auto font-medium" data-id="element-170">
            Mirá si alguna de estas situaciones te suena familiar…
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6 mb-12" data-id="element-171">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-[#132A44] border border-red-500/20 border-l-4 border-l-red-500/40 rounded-xl p-5 sm:p-6 hover:border-red-500/40 hover:border-l-red-500/80 transition-all flex items-start gap-4" data-id="element-172">
              <div className="flex-shrink-0 mt-1 flex flex-col items-center gap-2" data-id="element-173">
                <span className="text-xs font-black text-red-400 bg-red-500/10 px-2 py-1 rounded-md" data-id="element-174">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <p className="text-[#F2F4F8]/90 text-base sm:text-lg leading-relaxed pt-1" data-id="element-175">
                {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto mb-24" data-id="element-176">
          <div className="bg-gradient-to-r from-red-500/5 via-red-500/10 to-red-500/5 border border-red-500/20 rounded-2xl p-6 sm:p-8 text-center shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-177">
            <p className="text-xl sm:text-2xl text-[#F2F4F8] font-medium leading-relaxed" data-id="element-178">
              Si te sentiste identificado con al menos una de estas situaciones…{' '}
              <span className="font-bold text-red-400" data-id="element-179">
                este manual fue hecho para vos.
              </span>
            </p>
          </div>
        </motion.div>

        {/* BLOCK 2 — Transition */}
        <div className="border-t border-[#F2F4F8]/10 pt-20 relative mb-24" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center relative" data-id="element-181">
            <div className="absolute left-1/2 -top-28 transform -translate-x-1/2" data-id="element-182">
              <div className="w-12 h-12 bg-[#2F6BFF]/20 rounded-full flex items-center justify-center animate-bounce border border-[#2F6BFF]/30" data-id="element-183">
                <ArrowDownIcon className="w-6 h-6 text-[#2F6BFF]" data-id="element-184" />
              </div>
            </div>

            <div className="bg-[#0B1C2C]/50 border border-[#2F6BFF]/10 rounded-3xl p-8 sm:p-12 max-w-4xl mx-auto" data-id="element-185">
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-186"></h3>
              <div className="max-w-3xl mx-auto space-y-4 mt-8" data-id="element-187">
                <h3 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] leading-tight" data-id="element-188">
                  ¿Querés saber si lo que estas tomando{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-189">
                    realmente tiene Creatina
                  </span>
                  ?
                </h3>
                <p className="text-lg text-[#7EC8FF] font-semibold" data-id="element-190">
                  ⚠️ Dentro del pack vas a encontrar una cosa que nadie se
                  atreve a mostrar ⚠️
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* BLOCK 3 — Two-Pillar Solution */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-24" data-id="element-191">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-b from-[#132A44] to-[#0B1C2C] border-2 border-[#2F6BFF]/30 rounded-2xl p-8 sm:p-10 relative overflow-hidden group hover:border-[#2F6BFF]/60 transition-all" data-id="element-192">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#2F6BFF]/5 rounded-bl-full -z-0" data-id="element-193"></div>

            <div className="absolute top-6 right-6 z-20" data-id="element-194">
              <span className="bg-[#FFE600] text-[#0B1C2C] text-xs font-black px-3 py-1 rounded-full tracking-wider" data-id="element-195">
                EXCLUSIVO
              </span>
            </div>

            <div className="w-16 h-16 bg-[#2F6BFF]/20 rounded-2xl flex items-center justify-center mb-8 relative z-10" data-id="element-196">
              <FlaskConicalIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-197" />
            </div>

            <div className="mb-8 relative z-10" data-id="element-198">
              <div className="flex items-center gap-3 mb-2" data-id="element-199">
                <span className="text-6xl sm:text-7xl font-black text-[#2F6BFF] leading-none" data-id="element-200">
                  35
                </span>
                <span className="text-xl text-[#F2F4F8]/80 font-bold leading-tight max-w-[150px]" data-id="element-201">
                  marcas analizadas en laboratorio
                </span>
              </div>
            </div>

            <p className="text-[#F2F4F8]/80 text-lg mb-6 relative z-10" data-id="element-202">
              Incluye los resultados crudos de laboratorio de 35 marcas de
              creatina que fueron analizadas por un proyecto independiente en{' '}
              <span className="text-[#7EC8FF] font-bold" data-id="element-203">Argentina</span>.
            </p>

            <div className="mb-6 relative z-10" data-id="element-204">
              <p className="text-[#F2F4F8]/90 font-semibold mb-3" data-id="element-205">
                Este proyecto se dedicó a:
              </p>
              <ul className="space-y-2" data-id="element-206">
                {['comprar las creatinas más populares del mercado', 'enviarlas a analizar en laboratorio', 'comparar lo que dice la etiqueta vs lo que realmente contiene el producto'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-207">
                    <CheckCircle2Icon className="w-5 h-5 text-[#7EC8FF] flex-shrink-0 mt-0.5" data-id="element-208" />
                    <span className="text-[#F2F4F8]/70" data-id="element-209">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-[#FFE600]/10 border border-[#FFE600]/40 rounded-xl p-4 mb-6 relative z-10" data-id="element-210">
              <p className="text-[#FFE600] font-bold text-center text-lg" data-id="element-211">
                Osea... Desenmascarar las mentiras del marketing de suplementos.
              </p>
            </div>

            <ul className="space-y-2 mb-8 relative z-10" data-id="element-212">
              {['esta información no es pública', 'tiene costo de adquisición', 'nunca había sido presentada de forma accesible para consumidores'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2F6BFF] mt-2.5 flex-shrink-0" data-id="element-214"></div>
                  <span className="text-[#F2F4F8]/60 italic" data-id="element-215">{item}</span>
                </li>)}
            </ul>

            <p className="text-[#F2F4F8] font-medium text-lg border-t border-[#2F6BFF]/20 pt-6 relative z-10" data-id="element-216">
              Ahora vas a poder acceder a estos datos y saber qué marcas
              realmente cumplen lo que prometen.
            </p>
          </motion.div>

          {/* Card 2 */}
        </div>

        {/* BLOCK 4 — Final Bold Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto bg-gradient-to-r from-[#2F6BFF]/10 via-[#7EC8FF]/10 to-[#2F6BFF]/10 p-8 sm:p-12 rounded-3xl border border-[#2F6BFF]/20 shadow-[0_0_50px_rgba(47,107,255,0.1)]" data-id="element-217">
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#F2F4F8] mb-6 leading-tight" data-id="element-218">
            Después de ver esto....{' '}
            <span className="text-[#FFE600]" data-id="element-219">NO HAY VUELTA ATRAS</span>
          </h3>
          <p className="text-xl sm:text-2xl text-[#F2F4F8]/80 mb-4 font-medium" data-id="element-220">
            Ya no vas a ver la industria de suplementos de la misma manera.
          </p>
          <p className="text-xl sm:text-2xl text-[#F2F4F8] font-bold mb-10" data-id="element-221">
            Confío en que podrás dimensionar el poder de la información que
            estas a punto de obtener!!
          </p>

          <div className="flex flex-col items-center" data-id="element-222">
            <CTAButton size="large" className="w-full sm:w-auto mb-4" data-id="element-223">
              Quiero Acceder al Manual →
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-3 text-[#F2F4F8]/50 text-sm font-medium" data-id="element-224">
              <span data-id="element-225">🔒 Pago seguro con MercadoPago</span>
              <span className="hidden sm:inline" data-id="element-226">•</span>
              <span data-id="element-227">⚡ Descarga Inmediata</span>
              <span className="hidden sm:inline" data-id="element-228">•</span>
              <span data-id="element-229">✅ Garantía 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}